module.exports = __webpack_public_path__ + "static/media/app-store.f02ff994.png";